import { useUiStore, type UiLanguage } from "@/core/stores/ui.store";

export const SUPPORTED_LANGUAGES: UiLanguage[] = ["fr", "en", "zh"];

type LanguageResolver = () => string | undefined;

let resolver: LanguageResolver | undefined;

/**
 * Enregistre le résolveur prioritaire de langue (typiquement l'instance i18n,
 * via `@/app/i18n`). Permet à `core` de consommer la langue sans importer
 * `app` (inversion de dépendance évitée).
 */
export const registerLanguageResolver = (fn: LanguageResolver): void => {
  resolver = fn;
};

const clampToSupported = (lng: string | undefined): string | undefined => {
  const short = (lng || "").split("-")[0];
  return (SUPPORTED_LANGUAGES as string[]).includes(short) ? short : undefined;
};

/**
 * Résolveur canonique de la langue courante : résolveur enregistré (i18n)
 * d'abord, puis store UI (persisté), puis navigateur, puis "fr". Consommé par
 * la couche API (Accept-Language, messages multilingues `{ fr, en }`).
 */
export const getCurrentLanguage = (): string =>
  clampToSupported(resolver?.()) ||
  clampToSupported(useUiStore.getState().language) ||
  (typeof navigator !== "undefined"
    ? clampToSupported(navigator.language)
    : undefined) ||
  "fr";
